import { useEffect } from 'react';
import "./TermsOfUse.css";

export default function TermsOfUse() {
    useEffect(() => {
        document.title = 'תנאי שימוש | ZmanUp';
    }, []);

    const handleBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    };

    return (
        <main className="terms-of-use-container" dir="rtl">
            <article className="terms-of-use-content">
                <button type="button" className="terms-of-use-back" onClick={handleBack}>
                    → חזרה
                </button>

                <h1 className="terms-of-use-title">תנאי שימוש – ZmanUp</h1>
                <p className="terms-of-use-subtitle">עודכן לאחרונה: [ספטמבר 2026]</p>

                <h2 className="terms-of-use-heading">1. כללי</h2>
                <p className="terms-of-use-text">
                    1.1 תנאי שימוש אלה ("התנאים") מהווים הסכם מחייב בינך לבין מיכאל מלז׳יק, עוסק פטור מס' 33418512, הפועל תחת השם המסחרי ZmanUp (להלן: "ZmanUp" או "אנו").
                    <br />
                    1.2 התנאים חלים על האתרים zmanup.com ו-zmanup.co.il, על אפליקציות ZmanUp ל-iOS ול-Android ועל כל השירותים הקשורים בהם (להלן יחד: "השירות").
                    <br />
                    1.3 בהרשמה לשירות, בקביעת תור באמצעותו או בכל שימוש אחר בו, אתה מאשר שקראת את התנאים ואת מדיניות הפרטיות ומסכים להם. אם אינך מסכים – אין להשתמש בשירות.
                    <br />
                    1.4 מדיניות הפרטיות של ZmanUp, הזמינה בשירות ובאתר ZmanUp מהווה חלק בלתי נפרד מתנאים אלה.
                    <br />
                    1.5 התנאים מנוסחים בלשון זכר מטעמי נוחות בלבד ומתייחסים לכל המגדרים.
                </p>

                <h2 className="terms-of-use-heading">2. הגדרות</h2>
                <p className="terms-of-use-text">
                    • "משתמש עסקי" – אדם או תאגיד, לרבות מאסטר או סלון, שנרשם לשירות לצורך ניהול העסק שלו, לרבות בתקופת ניסיון.
                    <br />
                    • "עובד" – מי שהמשתמש העסקי העניק לו גישה לחשבונו, כגון עובד בסלון.
                    <br />
                    • "לקוח קצה" – מי שקובע תור אצל משתמש עסקי באמצעות השירות, או שהמשתמש העסקי מזין את פרטיו לשירות.
                    <br />
                    • "דף העסק" – דף ציבורי של המשתמש העסקי בשירות, המציג את פרטי העסק ומאפשר קביעת תורים.
                    <br />
                    • "תוכן העסק" – כל מידע, טקסט, תמונה, מחיר, שאלון או קובץ שהמשתמש העסקי או עובדיו מעלים לשירות.
                    <br />
                    • "חבילת הודעות" – מכסת הודעות שנרכשה מראש לצורך שליחת הודעות SMS ו/או WhatsApp באמצעות השירות.
                </p>

                <h2 className="terms-of-use-heading">3. הרשמה וחשבון</h2>
                <p className="terms-of-use-text">
                    3.1 ההרשמה כמשתמש עסקי מותרת לבני 18 ומעלה בלבד.
                    <br />
                    3.2 עליך למסור פרטים נכונים ומלאים ולעדכן אותם בעת הצורך.
                    <br />
                    3.3 אתה אחראי לשמירת סודיות פרטי הגישה לחשבונך ולכל פעולה שנעשית בו. יש להודיע לנו מיד על כל חשד לשימוש בלתי מורשה.
                    <br />
                    3.4 המשתמש העסקי אחראי לפעולות עובדיו בחשבון, להרשאות שהעניק להם ולביטולן כאשר אינן נדרשות עוד.
                    <br />
                    3.5 כחלק מהשירות, ZmanUp רשאית לשלוח למשתמש העסקי, באמצעי הקשר שמסר, הודעות שירות ותפעול הקשורות באופן סביר להרשמה, להשלמת תהליך ההצטרפות וה-Onboarding, להפעלת החשבון, לאבטחתו, להגדרות החשבון והשירות, לתמיכה ולשימוש בפועל ב-ZmanUp. הודעות אלה מהוות חלק מהשירות ואינן מיועדות לפרסום או לשיווק, ולא יכללו מבצעים, פרסומות או הצעות שיווקיות שאינן נדרשות לצורך מתן השירות.
                </p>

                <h2 className="terms-of-use-heading">4. תקופת ניסיון</h2>
                <p className="terms-of-use-text">
                    4.1 משתמש עסקי חדש זכאי לתקופת ניסיון של 14 יום ללא תשלום.
                    <br />
                    4.2 בתום תקופת הניסיון לא יבוצע חיוב אוטומטי. להמשך שימוש מלא יש לרכוש מנוי. עד לרכישת מנוי, הגישה לחלק מהפונקציות של השירות עשויה להיות מוגבלת.
                    <br />
                    4.3 ZmanUp רשאית לסרב להעניק תקופת ניסיון נוספת לאותו עסק.
                </p>

                <h2 className="terms-of-use-heading">5. מנוי ותשלום</h2>
                <p className="terms-of-use-text">
                    5.1 המנוי נרכש לתקופה חודשית או שנתית, לפי בחירת המשתמש העסקי. המחירים ותכולת המסלולים מפורסמים בשירות ובעמוד המחירים באתר ZmanUp.
                    <br />
                    5.2 המנוי אינו מתחדש אוטומטית. בתום התקופה יש לחדש את המנוי באופן יזום. ZmanUp עשויה לשלוח תזכורת לקראת תום התקופה, אך האחריות לחידוש מוטלת על המשתמש העסקי.
                    <br />
                    5.3 התשלום מתבצע באמצעות ספק סליקה חיצוני. פרטי כרטיס האשראי מוזנים ישירות אצל ספק הסליקה ואינם נשמרים אצל ZmanUp.
                    <br />
                    5.4 ZmanUp היא עוסק פטור ואינה גובה מע"מ. על כל תשלום תופק קבלה.
                    <br />
                    5.5 ZmanUp רשאית לשנות את המחירים. שינוי מחיר יחול רק על רכישה או חידוש שיבוצעו לאחר מועד השינוי, ולא על תקופה ששולמה מראש. על שינוי מחיר תימסר הודעה לפחות 30 יום מראש.
                    <br />
                    5.6 בתום תקופת המנוי ללא חידוש, החשבון יעבור למצב מוגבל. הנתונים יישמרו, והמשתמש העסקי יוכל לחדש את המנוי או לייצא את נתוניו.
                </p>

                <h2 className="terms-of-use-heading">6. ביטול מנוי והחזרים</h2>
                <p className="terms-of-use-text">
                    6.1 ניתן לבטל את המנוי בכל עת בפנייה ל-<a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a> או בהודעת WhatsApp למספר 972509718887+.
                    <br />
                    6.2 בביטול מנוי יוחזר למשתמש העסקי הסכום בגין הימים שנותרו עד תום התקופה, לפי חישוב יחסי: הסכום ששולם, בניכוי החלק היחסי בגין הימים שבהם המנוי היה בתוקף עד מועד הביטול. החישוב ייעשה לפי המחיר ששולם בפועל.
                    <br />
                    6.3 ההחזר יבוצע בתוך 14 יום ממועד הביטול, לאמצעי התשלום שבו בוצעה העסקה.
                    <br />
                    6.4 אין באמור כדי לגרוע מזכויות שהדין מקנה, ככל שהן חלות.
                </p>

                <h2 className="terms-of-use-heading">7. חבילות הודעות</h2>
                <p className="terms-of-use-text">
                    7.1 משתמש עסקי רשאי לרכוש חבילות הודעות לשליחת SMS ו/או WhatsApp ללקוחותיו באמצעות השירות. המחירים מפורסמים בשירות.
                    <br />
                    7.2 מספר ההודעות הזמינות בחבילת ההודעות יופחת בהתאם למספר ההודעות שנשלחו באמצעות השירות. מספר ההודעות שינוכה עשוי להשתנות בהתאם לערוץ (SMS או WhatsApp), לסוג ההודעה, לאורכה וליעדה.
                    <br />
                    7.3 הודעה שלא נשלחה בשל תקלה אצל ZmanUp לא תנוכה ממספר ההודעות הזמינות בחבילת ההודעות. ZmanUp אינה אחראית לאי-מסירת הודעה מסיבות שאינן בשליטתה, כגון מספר שגוי, חסימה על ידי הנמען או תקלה אצל מפעיל התקשורת או אצל WhatsApp.
                    <br />
                    7.4 הודעות שנרכשו במסגרת חבילת הודעות ולא נוצלו אינן פגות כל עוד החשבון פעיל. הודעות שלא נוצלו אינן ניתנות להחזר, למעט כמתחייב מהדין.
                </p>

                <h2 className="terms-of-use-heading">8. שימוש מותר ואסור</h2>
                <p className="terms-of-use-text">
                    8.1 השירות מיועד לניהול העסק, היומן והתורים, ולתקשורת עם לקוחות בהתאם לדין.
                    <br />
                    8.2 חל איסור:
                    <br />
                    • להשתמש בשירות לכל מטרה בלתי חוקית או בניגוד לתנאים אלה;
                    <br />
                    • להעלות מידע על אדם ללא זכות לעשות כן;
                    <br />
                    • להעלות תוכן הפוגע בזכויות יוצרים, בסימני מסחר, בפרטיות או בזכויות אחרות, או תוכן פוגעני, מטעה או מזיק;
                    <br />
                    • לשלוח דברי פרסומת ללא הסכמה כנדרש בדין (ספאם);
                    <br />
                    • למכור, להשכיר או להעביר לאחר גישה לשירות, שלא באמצעות מנגנון העובדים;
                    <br />
                    • לנסות לחדור לשירות, לעקוף אמצעי אבטחה, להפעיל כלים אוטומטיים לאיסוף מידע (scraping) או לפגוע בפעילות השירות;
                    <br />
                    • להעתיק את השירות, לבצע בו הנדסה לאחור או ליצור שירות מתחרה על בסיסו.
                </p>

                <h2 className="terms-of-use-heading">9. הודעות ללקוחות קצה</h2>
                <p className="terms-of-use-text">
                    9.1 המשתמש העסקי אחראי לתוכן ההודעות שהוא שולח ללקוחותיו באמצעות השירות ולעמידה בדין, לרבות קבלת הסכמה לשליחת דברי פרסומת לפי סעיף 30א לחוק התקשורת (בזק ושידורים), התשמ"ב-1982, וכן למדיניות של WhatsApp.
                    <br />
                    9.2 ZmanUp רשאית לבדוק תבניות והודעות, לעכב או לחסום את שליחתן ולהשעות את אפשרות השליחה, אם יש לה יסוד להניח שהן מפרות את הדין, את התנאים או את מדיניות ספקי התקשורת.
                    <br />
                    9.3 ZmanUp אינה מתחייבת למסירת הודעות במועד מסוים או בכלל, כמפורט בסעיף 7.3.
                </p>

                <h2 className="terms-of-use-heading">10. תשלומים ומסמכים חשבונאיים של העסק</h2>
                <p className="terms-of-use-text">
                    10.1 השירות מאפשר חיבור לספקי סליקה ולספקי הפקת מסמכים חיצוניים. ההתקשרות עם ספקים אלה היא בין המשתמש העסקי לבין הספק. ZmanUp אינה צד לה ואינה אחראית לפעילות הספקים.
                    <br />
                    10.2 ZmanUp אינה צד לעסקאות בין המשתמש העסקי לבין לקוחותיו ואינה מקבלת או מחזיקה כספים עבור המשתמש העסקי או עבור לקוחותיו. התשלום מתבצע באמצעות ספק הסליקה המחובר לחשבון המשתמש העסקי.
                    <br />
                    10.3 ככל שהשירות מאפשר למשתמש העסקי לדרוש מקדמה או תשלום מראש, ZmanUp מספקת תשתית טכנולוגית בלבד לצורך הצגת דרישת התשלום והפניית לקוח הקצה לספק הסליקה. המשתמש העסקי הוא שקובע את סכום המקדמה, תנאי הביטול וההחזר, והוא האחראי הבלעדי לקיום תנאים אלה ולביצוע החזר כספי, ככל שנדרש לפי תנאיו או לפי דין. ZmanUp אינה משמשת כנאמן, כמחזיקת כספים, כצד לעסקה או כגורם המכריע במחלוקת בין המשתמש העסקי לבין לקוח הקצה.
                    <br />
                    10.4 המשתמש העסקי אחראי לנכונות הקבלות, החשבוניות והמסמכים החשבונאיים המופקים עבורו באמצעות ספק חיצוני המחובר לשירות, וכן לדיווח לרשויות המס ולשמירת המסמכים כנדרש בדין. ZmanUp מספקת את החיבור הטכנולוגי לספק ואינה הגורם המפיק את המסמך החשבונאי.
                </p>

                <h2 className="terms-of-use-heading">11. שאלונים ומידע רגיש</h2>
                <p className="terms-of-use-text">
                    11.1 השירות מאפשר למשתמש העסקי להציג ללקוחותיו שאלונים ולצרף טפסים, לרבות שאלות בנושאים רפואיים הנוגעים לטיפול.
                    <br />
                    11.2 המשתמש העסקי אחראי לתוכן השאלות, לכך שייאסף רק מידע הנחוץ לטיפול, להודעה ללקוח למי נמסר המידע ולאיזו מטרה, ולקבלת הסכמתו כנדרש בדין. ZmanUp אינה בודקת את תוכן השאלונים והתשובות ואינה אחראית לו.
                </p>

                <h2 className="terms-of-use-heading">12. תוכן העסק</h2>
                <p className="terms-of-use-text">
                    12.1 תוכן העסק שייך למשתמש העסקי, והוא האחראי הבלעדי לנכונותו, לחוקיותו ולכך שיש לו את הזכויות הנדרשות בו.
                    <br />
                    12.2 המשתמש העסקי מעניק ל-ZmanUp רישיון לא בלעדי וללא תמורה לאחסן, לעבד ולהציג את תוכן העסק ככל שהדבר נדרש להפעלת השירות, לרבות הצגת פרטי העסק (שם, תחום, עיר, שירותים, מחירים ותמונות) בדף העסק, בתוצאות חיפוש בשירות ובקטלוג בעלי המקצוע של ZmanUp. ככל שהשירות מאפשר זאת, המשתמש העסקי רשאי לבחור שלא להופיע בקטלוג. הרישיון מסתיים עם מחיקת התוכן או סגירת החשבון, בכפוף לזמן סביר הנדרש להסרה.
                    <br />
                    12.3 פרסום תמונות של לקוחות קצה (כגון תמונות "לפני ואחרי") מותר רק בהסכמת הלקוח המצולם. האחריות לקבלת ההסכמה מוטלת על המשתמש העסקי.
                    <br />
                    12.4 ZmanUp רשאית להסיר תוכן המפר את הדין או את התנאים.
                </p>

                <h2 className="terms-of-use-heading">13. קניין רוחני של ZmanUp</h2>
                <p className="terms-of-use-text">
                    13.1 השירות, לרבות העיצוב, הקוד, הטקסטים, הסימנים המסחריים והשם ZmanUp, הם קניינה של ZmanUp או של מי שהעניק לה רישיון. ZmanUp מעניקה לך רשות שימוש אישית, לא בלעדית ובלתי ניתנת להעברה בשירות, בהתאם לתנאים אלה ולמשך תקופת השימוש.
                    <br />
                    13.2 אין להשתמש בקניין הרוחני של ZmanUp שלא כמותר בתנאים אלה ללא אישור מראש ובכתב.
                </p>

                <h2 className="terms-of-use-heading">14. עיבוד מידע של לקוחות קצה מטעם העסק</h2>
                <p className="terms-of-use-text">
                    14.1 לגבי מידע על לקוחות קצה, המשתמש העסקי הוא בעל השליטה במאגר המידע, ו-ZmanUp היא מחזיק המעבד את המידע מטעמו ובהתאם להוראותיו. סעיף זה מסדיר את חלוקת התפקידים בין הצדדים לעניין עיבוד מידע זה, לרבות לצורך חוק הגנת הפרטיות, התשמ"א-1981 ותקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017.
                    <br />
                    14.2 ZmanUp:
                    <br />
                    • תעבד את המידע רק לצורך מתן השירות למשתמש העסקי ולפי הוראותיו, כפי שהן באות לידי ביטוי בשימוש בשירות ובהגדרותיו, ולא לכל מטרה אחרת;
                    <br />
                    • תנקוט אמצעי אבטחה כמפורט במדיניות הפרטיות ובהתאם לדין;
                    <br />
                    • תעניק גישה למידע רק למי שהדבר נדרש לתפקידו ושהתחייב לשמור על סודיות;
                    <br />
                    • רשאית להיעזר בספקי שירות בקטגוריות המפורטות במדיניות הפרטיות, בכפוף להתחייבותם להגן על המידע;
                    <br />
                    • תסייע למשתמש העסקי, במידה סבירה, בטיפול בבקשות של לקוחות קצה לעיון במידע, לתיקונו או למחיקתו;
                    <br />
                    • תודיע למשתמש העסקי ללא דיחוי על אירוע אבטחה חמור הנוגע למידע שלו;
                    <br />
                    • בסיום ההתקשרות תאפשר ייצוא של הנתונים ותמחק אותם כמפורט בסעיף 17.
                    <br />
                    14.3 המשתמש העסקי מצהיר שהוא רשאי למסור את המידע ל-ZmanUp לצורך השירות ושמילא את חובותיו כלפי לקוחותיו לפי הדין.
                </p>

                <h2 className="terms-of-use-heading">15. לקוחות קצה</h2>
                <p className="terms-of-use-text">
                    15.1 ZmanUp מספקת פלטפורמה לקביעת תורים בלבד. השירות או הטיפול ניתן על ידי המשתמש העסקי, וההתקשרות לגביו, לרבות מחיר, תשלום, מקדמה, ביטול ואיחורים, היא בין לקוח הקצה לבין המשתמש העסקי ולפי תנאיו.
                    <br />
                    15.2 ZmanUp אינה אחראית לאיכות השירות שנתן המשתמש העסקי, לזמינותו או לכל נזק הנובע משירות זה.
                    <br />
                    15.3 לקוח קצה המשתמש בשירות מתחייב למסור פרטים נכונים ולא לקבוע תורים פיקטיביים.
                </p>

                <h2 className="terms-of-use-heading">16. זמינות השירות ותקלות</h2>
                <p className="terms-of-use-text">
                    16.1 ZmanUp פועלת כדי שהשירות יהיה זמין ותקין ומבצעת גיבויים שוטפים, אך אינה מתחייבת שהשירות יפעל ללא הפסקות או תקלות. ייתכנו הפסקות לצורך תחזוקה ועדכונים, ככל האפשר בהודעה מראש.
                    <br />
                    16.2 מומלץ למשתמש העסקי לייצא מעת לעת את נתוניו החיוניים.
                    <br />
                    16.3 ZmanUp רשאית לשנות, להוסיף או להסיר פונקציות בשירות. שינוי מהותי הפוגע בפונקציה מרכזית של מנוי בתשלום יזכה את המשתמש העסקי לבטל את המנוי ולקבל החזר כמפורט בסעיף 6.
                </p>

                <h2 className="terms-of-use-heading">17. השעיה וסיום</h2>
                <p className="terms-of-use-text">
                    17.1 ZmanUp רשאית להשעות או לסגור חשבון, לאחר הודעה מראש ככל שהדבר אפשרי, במקרה של הפרת התנאים או הדין, שליחת ספאם, חשש להונאה או לפגיעה באבטחה, או אי-תשלום.
                    <br />
                    17.2 במקרה של הפרה חמורה או סכנה מיידית לשירות או למשתמשים, ZmanUp רשאית להשעות את החשבון באופן מיידי.
                    <br />
                    17.3 המשתמש העסקי רשאי לסגור את חשבונו בכל עת. מומלץ לייצא את הנתונים לפני הסגירה.
                    <br />
                    17.4 לאחר סגירת חשבון, הנתונים יימחקו כמפורט במדיניות הפרטיות, בכפוף לחובות שמירה לפי דין.
                    <br />
                    17.5 ZmanUp רשאית למחוק חשבון שאין בו מנוי פעיל ושלא נעשה בו שימוש במשך 12 חודשים, לאחר הודעה למשתמש העסקי לפחות 30 יום מראש.
                </p>

                <h2 className="terms-of-use-heading">18. אחריות והגבלתה</h2>
                <p className="terms-of-use-text">
                    18.1 השירות ניתן כפי שהוא (AS IS). ZmanUp אינה מתחייבת שהשירות יתאים לצרכים המיוחדים של כל עסק.
                    <br />
                    18.2 ZmanUp לא תהיה אחראית לנזק עקיף או תוצאתי, לרבות אובדן רווח, הכנסה, לקוחות או מוניטין.
                    <br />
                    18.3 האחריות הכוללת של ZmanUp בכל הקשור לשירות לא תעלה על הסכום ששילם המשתמש העסקי ל-ZmanUp ב-12 החודשים שקדמו לאירוע שבגינו נטענת האחריות.
                    <br />
                    18.4 הגבלות האחריות בסעיף זה לא יחולו על נזק שנגרם בזדון או ברשלנות רבתי של ZmanUp, או ככל שהדין אינו מתיר להגביל את האחריות.
                </p>

                <h2 className="terms-of-use-heading">19. שיפוי</h2>
                <p className="terms-of-use-text">
                    המשתמש העסקי ישפה את ZmanUp בגין תביעה, דרישה, נזק או הוצאה סבירה, לרבות שכר טרחת עורך דין, הנובעים מתוכן שהמשתמש העסקי או עובדיו העלו, פרסמו או מסרו באמצעות השירות, מהודעות שנשלחו על ידם, מהשירותים שהם מספקים ללקוחותיהם, או מהפרת תנאים אלה או הוראות הדין על ידם, ובלבד ש-ZmanUp הודיעה למשתמש העסקי על התביעה או הדרישה ואפשרה לו, ככל שניתן באופן סביר, להתגונן מפניה.
                </p>

                <h2 className="terms-of-use-heading">20. כוח עליון</h2>
                <p className="terms-of-use-text">
                    ZmanUp לא תישא באחריות לעיכוב או לאי-ביצוע הנובעים מנסיבות שאינן בשליטתה הסבירה, לרבות מלחמה, פעולות איבה, מצב חירום, אסון טבע, הפסקות חשמל או תקשורת נרחבות ותקלות אצל ספקי תשתית.
                </p>

                <h2 className="terms-of-use-heading">21. שינויים בתנאים</h2>
                <p className="terms-of-use-text">
                    ZmanUp רשאית לעדכן את התנאים מעת לעת. על שינויים מהותיים תימסר הודעה למשתמשים העסקיים בדוא"ל או בהודעה בשירות, לפחות 14 יום לפני כניסתם לתוקף. משתמש עסקי שאינו מסכים לשינוי רשאי לבטל את המנוי ולקבל החזר כמפורט בסעיף 6. המשך השימוש בשירות לאחר כניסת השינוי לתוקף מהווה הסכמה לו.
                </p>

                <h2 className="terms-of-use-heading">22. שפה</h2>
                <p className="terms-of-use-text">
                    התנאים עשויים להיות מוצגים גם בשפות נוספות. במקרה של סתירה בין הנוסחים, הנוסח העברי הוא הקובע.
                </p>

                <h2 className="terms-of-use-heading">23. הדין החל וסמכות שיפוט</h2>
                <p className="terms-of-use-text">
                    על תנאים אלה יחולו דיני מדינת ישראל בלבד. סמכות השיפוט הבלעדית נתונה לבתי המשפט המוסמכים בתל אביב-יפו, ככל שהדין מתיר זאת.
                </p>

                <h2 className="terms-of-use-heading">24. יצירת קשר</h2>
                <p className="terms-of-use-text">
                    לכל פנייה בנוגע לתנאים אלה: בדוא"ל <a href="mailto:support@zmanup.co.il">support@zmanup.co.il</a> או ב-WhatsApp למספר 972509718887+.
                </p>
            </article>
        </main>
    );
}
